import React, { useState, useEffect } from "react";
import PageHeader from "../../components/common/ui/PageHeader";
import BoardToolbar from "../../components/common/board/BoardToolbar";
import BoardTable from "../../components/common/board/BoardTable";
import BoardPagination from "../../components/common/board/BoardPagination";
import { formatDate } from "../../utils/date";

const MOCK_DATA = [
  {
    id: 1,
    orderId: "PO-20231201-001",
    itemName: "PC Column C1",
    spec: "500x500x3000",
    quantity: 10,
    status: "planned",
    plannedDate: "2023-12-20",
    manager: "김철수",
  },
  {
    id: 2,
    orderId: "PO-20231202-002",
    itemName: "PC Beam B2",
    spec: "400x600x6000",
    quantity: 5,
    status: "in_production",
    plannedDate: "2023-12-22",
    manager: "이영희",
  },
  {
    id: 3,
    orderId: "PO-20231205-003",
    itemName: "Wall Panel W1",
    spec: "200x2400x3000",
    quantity: 20,
    status: "produced",
    plannedDate: "2023-12-25",
    manager: "박지수",
  },
  {
    id: 4,
    orderId: "PO-20231208-004",
    itemName: "PC Slab S1",
    spec: "150x1200x2400",
    quantity: 50,
    status: "delivered",
    plannedDate: "2023-12-28",
    manager: "최민호",
  },
  {
    id: 5,
    orderId: "PO-20231210-005",
    itemName: "Stair ST1",
    spec: "Type A",
    quantity: 2,
    status: "installed",
    plannedDate: "2024-01-05",
    manager: "정우성",
  },
];

const STATUS_LABELS = {
  planned: "계획됨",
  in_production: "생산중",
  produced: "생산완료",
  delivered: "반입완료",
  installed: "설치완료",
};

const STATUS_COLORS = {
  planned: "bg-gray-100 text-gray-800",
  in_production: "bg-blue-100 text-blue-800",
  produced: "bg-purple-100 text-purple-800",
  delivered: "bg-orange-100 text-orange-800",
  installed: "bg-green-100 text-green-800",
};

const Prod = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    // Simulate API call
    setLoading(true);
    setTimeout(() => {
      setRows(MOCK_DATA);
      setTotal(MOCK_DATA.length);
      setLoading(false);
    }, 500);
  }, [page, pageSize]);

  const columns = [
    {
      key: "orderId",
      header: "발주번호",
      render: (row) => <span className="font-medium">{row.orderId}</span>,
    },
    {
      key: "itemName",
      header: "품명",
    },
    {
      key: "spec",
      header: "규격",
    },
    {
      key: "quantity",
      header: "수량",
      align: "center",
      headerAlign: "center",
    },
    {
      key: "status",
      header: "상태",
      align: "center",
      headerAlign: "center",
      render: (row) => (
        <span
          className={`px-2 py-1 rounded-full text-xs ${STATUS_COLORS[row.status] || "bg-gray-100 text-gray-800"
            }`}
        >
          {STATUS_LABELS[row.status] || row.status}
        </span>
      ),
    },
    {
      key: "plannedDate",
      header: "계획일",
      align: "center",
      headerAlign: "center",
    },
    {
      key: "manager",
      header: "담당자",
      align: "center",
      headerAlign: "center",
    },
  ];

  return (
    <div className="p-6">
      <PageHeader>생산 관리</PageHeader>

      <BoardToolbar
        right={
          <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition text-sm">
            + 생산 계획 등록
          </button>
        }
      />

      <BoardTable
        columns={columns}
        rows={rows}
        loading={loading}
        keyField="id"
        emptyMessage="생산 내역이 없습니다."
      />

      <BoardPagination
        page={page}
        pageSize={pageSize}
        total={total}
        onPageChange={setPage}
      />
    </div>
  );
};

export default Prod;